(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    /*Mobile Footer Menu Start*/
  //      $(document).ready(function() {
  //       $('.footer__blocks-wrapper .footer-block').each(function() {
  //       const lenCount = $(this).find('.footer-block__details-content li').length;
  //       if (lenCount <= 1) {
  //         $(this).addClass('ftr-block-itemless');
  //       }
  //     });

  // });
    /*Mobile Footer Menu End*/
       /*Header Menu Start*/
         setTimeout(function(){
            $('.hdr-submenus .header__desktop-category-col .menu-col').each(function() {
              const lenCount = $(this).find('ul.mb2 li').length;
              if (lenCount >= 1) {
                $('<button class="submenusign" aria-label="Open SubMenu"></button>').appendTo($(this).find('.menu-col-title'));
              }
          });
           $(document).on('click', '.header-menu .submenusign', function() {
            console.log('233333')
             $(this).parents('.header__desktop-category-col .menu-col').find('.menu-col-title').toggleClass('navitem-sub-show');
         });

         },500);

    $('.header-menu .navitem .navinner, .header-menu .navitem .nav-open-btn').click(function(event) {
        event.stopPropagation(); // Prevents event bubbling if needed
        
        const navItem = $(this).closest('.navitem');

        // Check if the clicked element or its `.navinner` contains a `.nav-link` that is NOT `.velvet-x-cleo-wade`
        if (navItem.find('.nav-link').not('.velvet-x-cleo-wade').length) {
            navItem.siblings().removeClass('navitem-show');
            navItem.toggleClass('navitem-show');
            console.log("Menu open");
        }
    });

       /*Header Menu End*/
       class LocalizationForm extends HTMLElement {
         constructor() {
           super();
           this.elements = {
             input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
             button: this.querySelector('button'),
             panel: this.querySelector('.disclosure__list-wrapper'),
           };
           this.elements.button.addEventListener('click', this.openSelector.bind(this));
           this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
           this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

           this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
         }

         hidePanel() {
           this.elements.button.setAttribute('aria-expanded', 'false');
           this.elements.panel.setAttribute('hidden', true);
         }

         onContainerKeyUp(event) {
           if (event.code.toUpperCase() !== 'ESCAPE') return;

           this.hidePanel();
           this.elements.button.focus();
         }

         onItemClick(event) {
           event.preventDefault();
           const form = this.querySelector('form');
           this.elements.input.value = event.currentTarget.dataset.value;
           if (form) form.submit();
         }

         openSelector() {
           this.elements.button.focus();
           this.elements.panel.toggleAttribute('hidden');
           this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
         }

         closeSelector(event) {
           const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
           if (event.relatedTarget === null || shouldClose) {
             this.hidePanel();
           }
         }
       }

       customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

    document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.hdr-right-nav li .header__search svg.searchicon').addEventListener('click', () => {
      setTimeout(() => {
        document.querySelectorAll('.search__input.field__input.ss__autocomplete__input').forEach((item) => {
          item.focus();
          item.classList.add('searchfocus');
        });
    },500);
    setTimeout(() => {
        document.querySelectorAll('.search__input.field__input.ss__autocomplete__input').forEach((item) => {
          item.focus();
          item.classList.add('searchfocus');
        });
    },1000);  
  });
});

  
// Popular Search Start
async function fetchdata() {
    try {
        const apiEndpoint = 'https://kcz5w1.a.searchspring.io/api/suggest/trending?siteId=kcz5w1&limit=6';
        const popularData = await fetch(apiEndpoint);
        const data = await popularData.json();
        return data;
    } catch (error) {
        throw new Error(error)
    }
}

async function popularList() {
    const data = await fetchdata();
    const popularLinks = document.getElementsByClassName("popular-links");

    // Create an array of accessible list items
    const popularItems = data.trending.queries.map((item) => {
        const listItem = document.createElement("li");
        listItem.classList.add("popular-links__item");

        const link = document.createElement("a");

        const searchQuery = item.searchQuery?.trim() || "";

        link.href = `https://velvet-tees.com/collections/shop?q=${encodeURIComponent(searchQuery)}`;
        link.textContent = searchQuery;

        link.setAttribute("aria-label", `Search for ${searchQuery}`);
        link.setAttribute("title", searchQuery);
        listItem.appendChild(link);
        
        return listItem;
    });

    // Append cloned li items into each container
    for (let i = 0; i < popularLinks.length; i++) {
        popularItems.forEach((popularItem) => {
            popularLinks[i].appendChild(popularItem.cloneNode(true));
        });
    }
}

popularList();
// Popular Search End
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
    //   this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    //   this.closeMenuDisclosure();
    //   this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
